export const dashboard_functions = [
  'Founder',
  'Founders’ office',
  'C-suite',
  'Product',
  'Tech',
  'Sales',
  'Marketing',
  'Finance',
  'Human resources',
  'Customer success',
  'Strategy',
  'Operations',
  'Other',
]

export const getStartedChecklistData = (platform) => [
  {
    id: 0,
    title: 'Create an account',
    status: 'COMPLETE',
  },
  // {
  //   id: 1,
  //   title: 'Ask Arrowhead',
  //   description:
  //     'Your Chat GPT for meetings. Try the sample question to see the magic 🪄',
  //   buttonText: 'Open or',
  //   buttonShortcut: platform === 'Mac' ? '⌘ K' : 'Ctrl G',
  //   status: 'ACTIVE',
  // },
  {
    id: 1,
    title: 'View a meeting',
    description:
      'Click on a meeting to see all its details, from agenda to action items.',
    buttonText: 'Open Meeting',
    // buttonShortcut: platform === 'Mac' ? '⌘ K' : 'Ctrl G',
    status: 'ACTIVE',
  },
  {
    id: 2,
    title: 'Tag a meeting',
    description: 'Add tags to easily categorize and find meetings later.',
    buttonText: 'Add a tag',
    status: 'DEFAULT',
  },
  // {
  //   id: 4,
  //   title: 'Summon Arrowhead',
  //   description: 'Type keywords in the search bar to quickly perform actions.',
  //   buttonPreText: 'Press',
  //   buttonText: platform === 'Mac' ? '⌘ K' : 'Ctrl G',
  //   status: 'DEFAULT',
  // },
  // {
  //   id: 4,
  //   title: 'Invite a teammate',
  //   description:
  //     'Share the meeting link with your team and let Arrowhead handle the rest.',
  //   buttonText: 'Invite',
  //   buttonPostText: 'Skip for now',
  //   status: 'DEFAULT',
  // },
]

export const firstMeetingData = (name) => {
  return {
    event: {
      summary: [
        {
          id: 1,
          summary: `Welcome to Arrowhead, ${name}. Your AI-powered meeting assistant! As you embark on this journey, you’ll discover the power of seamless meeting management and insightful collaboration. You’re all set to become a power user, unlocking 10x insights from every meeting and saving precious time with Arrowhead’s help!`,
        },
      ],
      templatisedNotes: [
        {
          question: 'Benefits of Arrowhead',
          answer:
            'Smart AI-generated insights and summaries., Easy scheduling and organization of meetings.,Enhanced collaboration through tagging and sharing.,Time-saving with automated tasks and actions.',
        },
        {
          question: 'Key Features',
          answer:
            'AI-driven meeting summaries.,Powerful search capabilities.,Tagging system for easy categorization.,Seamless integration with Google Meet.,Intuitive UI for effortless navigation.',
        },
        {
          question: 'Still to be discovered',
          answer:
            'Advanced customization options.,Detailed analytics and reporting.,Collaboration with external users.,Access to upcoming features and improvements.',
        },
      ],
      actionItems: [
        {
          id: 1,
          item: 'Schedule a meeting with the Arrowhead team to learn more about how to use the platform',
        },
        {
          id: 2,
          item: 'Create a test meeting to try out different features and settings',
        },
        {
          id: 3,
          item: 'Invite team members to a meeting and assign action items to test the platforms collaboration capabilities',
        },
      ],
    },
  }
}

export const taggedMeetingData = {
  event: {
    title: 'Your First Meeting with Arrowhead',
    summary: [
      {
        id: 1,
        summary:
          'Introduction to Arrowhead bot, an AI-powered virtual assistant for smarter meetings Explanation of how Arrowhead bot works and what it can do Overview of the benefits of using Arrowhead bot',
      },
    ],
    templatisedNotes: [
      {
        question: 'What’s new',
        answer:
          'Smart AI-generated insights and summaries., Easy scheduling and organization of meetings.,Enhanced collaboration through tagging and sharing.,Time-saving with automated tasks and actions.',
      },
      {
        question: 'Discover more',
        answer:
          'Tagging Magic: Keep your meetings tidy and organized by using Arrowhead’s tagging feature. 🏷️🌟,Recurring Meetings Hub: Stay in control with quick access to your recurring meetings dashboard. 🔄📅,Auto-Join: Let the Arrowhead Bot automatically join your meetings for seamless integration. 🤖✨, Transcript Treasure: Enjoy auto-generated meeting transcripts, capturing every detail for future reference. 📜🔍',
      },
    ],
    actionItems: [
      {
        id: 1,
        user: 'Amy',
        item: 'to create draft assignment by Jan 3rd',
      },
      {
        id: 2,
        user: 'Amy',
        item: 'to review UI UX',
      },
      {
        id: 3,
        user: 'John',
        item: 'to complete tech evaluation',
      },

      {
        id: 4,
        user: 'John',
        item: 'to check pricing',
        status: 1,
      },
      {
        id: 5,
        user: 'Amy',
        item: 'to make onboarding',
        status: 1,
      },
    ],
  },
}

export const firstMeetingAnswer =
  'In the cheerful ’Start with Arrowhead’ meeting, our fantastic founder Devyani gave us a delightful walkthrough of the product. Here are the main objectives and goals we covered during this fun and informative session: Warmly welcome everyone and introduce the passionate team members., Share the inspiring vision and mission behind the product.Provide a friendly, step-by-step guide to using the product’s amazing features.,Highlight how the product uniquely solves users’ problems and makes their lives easier.,Discuss some exciting upcoming updates and improvements to the product.Answer any questions and address concerns with a caring and helpful attitude.Encourage team members to share their own creative ideas and feedback to make the product even better.,The ’Start with Arrowhead’ meeting left us all feeling inspired and excited about the product, and eager to contribute to its success!'

export const OnboardingtemplatisedNotes = (id) => {
  return [
    {
      'Benefits of Arrowhead': [
        {
          answer:
            'More efficient meetings that stay on track with automatic prompts and reminders',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer:
            'Increased engagement and participation from all attendees with personalized recommendations',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer:
            'Better decision-making with AI-generated insights and action items',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'More efficient meetings that stay on track',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
        {
          answer: 'Increased engagement and participation from all attendees',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
        {
          answer:
            'Better decision-making with AI-generated insights and action items',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
        {
          answer:
            'Time-saving features like auto-generated meeting notes and summaries',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
      ],
    },
    {
      'Key Features': [
        {
          answer:
            'Natural language processing for easy communication with the bot',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'Customizable settings for personalized meeting preferences',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'Action item tracking and assignment',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'Smart prompts and suggestions to improve meeting outcomes',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'Command K search for quick access to meeting information',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
        {
          answer: 'Automatic note-taking and summary generation',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
        {
          answer: 'Smart prompts and suggestions to improve meeting outcomes',
          title: 'Start with Arrowhead! 🏹🚀 ',
          event_id: `${id}_google_first_meeting`,
        },
      ],
    },
    {
      'Still to be discovered': [
        {
          answer: 'Integrations with other productivity tools',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer:
            'Customizable meeting templates for different types of meetings',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
        {
          answer: 'Team analytics and insights',
          title: 'Your first meeting with Arrowhead Bot',
          event_id: `${id}_google_tag_meeting`,
        },
      ],
    },
  ]
}
export const onboardingActionItems = [
  {
    id: 1,
    user: 'Amy',
    item: 'Schedule a meeting with the Arrowhead team to learn more about how to use the platform ',
  },
  {
    id: 2,
    user: 'Amy',
    item: 'Create a test meeting to try out different features and settings',
  },
  {
    id: 3,
    user: 'John',
    item: 'Invite team members to a meeting and assign action items to test the platforms collaboration capabilities',
  },

  {
    id: 4,
    user: 'John',
    item: 'Experiment with different meeting settings and preferences to find the best fit for your team',
  },
  {
    id: 5,
    user: 'Amy',
    item: 'Assign action items to the bot and test its ability to track and follow up on them',
  },
  {
    id: 6,
    user: 'John',
    item: 'Provide feedback and suggestions for improving the bots functionality and user experience',
  },
]
